module.exports = __webpack_public_path__ + "static/Web_Tarjetas_Cuenca-7643382d7bd43756bdbe0e69fbaaf49a.gif";